module.exports = __webpack_public_path__ + "img/slider_18.7af8b302.jpg";